var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart",style:({ 'height': _vm.height })},[_c('ECharts',{ref:"chart",staticStyle:{"overflow":"initial"},attrs:{"option":_vm.options,"setOptionOps":{ notMerge: true },"initOpts":{ renderer: 'svg' },"events":[
      ['legendselectchanged', _vm.handleLegendSelectChange ]
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }